import * as mdi from '@mdi/js';
import PropTypes from 'prop-types';

// 'movie-roll' → 'mdiMovieRoll', the export name of its path in @mdi/js.
const keyOf = (name) => 'mdi' + name.split('-').map((part) => part.charAt(0).toUpperCase() + part.slice(1)).join('');

// The SVG path of a MaterialCommunityIcons name (the same names the app draws), or undefined.
export const mdiPathOf = (name) => (name ? mdi[keyOf(name)] : undefined);
mdiPathOf.keyOf = keyOf;

// A pack's icon (a MaterialCommunityIcons name), or nothing when it has none or an unknown one.
const PackIcon = ({ name, size = 20, color = 'currentColor', style }) => {
  const path = mdiPathOf(name);
  if (!path) return null;
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} style={{ flex: 'none', ...style }} aria-label={name} role="img">
      <path d={path} fill={color} />
    </svg>
  );
};

PackIcon.propTypes = {
  name: PropTypes.string,
  size: PropTypes.number,
  color: PropTypes.string,
  style: PropTypes.object,
};

export default PackIcon;
